/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Hero_Title_BeforeInputs */

const da_forside_hero_title_before = /** @type {(inputs: Forside_Hero_Title_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ret terminsprøver`)
};

/** @type {(inputs: Forside_Hero_Title_BeforeInputs) => LocalizedString} */
const en_forside_hero_title_before = da_forside_hero_title_before;

/**

* @param {Forside_Hero_Title_BeforeInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_hero_title_before = /** @type {((inputs?: Forside_Hero_Title_BeforeInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Hero_Title_BeforeInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_hero_title_before(inputs)
	return /** @type {LocalizedString} */ ("Ret terminsprøver")
});